import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import {
  emailTimesheetVsSchedulingMonthlyReportAction,
  getTimeSheetVsSchedulingMonthlyReportAction,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
  resetTimesheetVsSchedulingMonthlyList,
  resetTimesheetVsSchedulingMonthlyTotalCount,
} from "../../../redux/timeSheet";
import { connect } from "react-redux";
import {
  EmailIconColor,
  EmailsIcon,
  EmptyTimeSheetReportList,
} from "../../../assets/images";
import InternalUsersDropdown from "../../../components/commons/InternalUsersDropdown/InternalUsersDropdown";
import ReportsDateSelect from "../../../components/commons/ReportsDateSelect/ReportsDateSelect";
import {
  formatDate,
  handleDate,
  reverseDateFormat,
} from "../../../utils/commonFunctions";
import TimesheetVsSchedulingMonthlyTable from "../../../components/TimeSheetReports/TimeSheetVsSchedulingMonthlyReport/TimesheetVsSchedulingMonthlyTable";
import {
  EmailTimesheetVsSchedulingMonthlyReportType,
  GetTimesheetVsSchedulngMonthlyReport,
} from "../../../commonTypes/timeSheetTypes";
import { TimesheetVsSchedulingMonthlyListType } from "../../../redux/timeSheet/timeSheetType";
import {
  TIMESHEET_SCHEDULING_BILLABLE_REPORT_HEADERS,
  TIMESHEET_VS_SCHEDULING_MONTHLY_REPORT_HEADERS,
} from "../../../constant/tableHeadersConstants/timeSheetConstants/timesheetVsSchedulingMonthlyReportConst";
import { SelectOptionType } from "../../../redux/scheduling/schedulingTypes";
import Select from "react-select";
import { GetUsersDepartmentPayloadType } from "../../../commonTypes/masterDataTypes";
import { getMasterDataUsersDepartmentAction } from "../../../redux/masterData";
import { DepartmentListType } from "../../../redux/clientSettings/clientSettingTypes";
import useDebounce from "../../../customHooks/useDebounce";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import EmailAllUserReportPopup from "../../../components/TimeSheetReports/EmailAllUserReportPopup";

type Appprops = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  totalCount: number;
  userDepartmentList: DepartmentListType[] | [];
  usersDepartmentFetching: boolean;
  totalDepartmentCount: number;
  usersEmailDepartmentFetching: boolean;
  timesheetVsSchedulingMonthlyList: TimesheetVsSchedulingMonthlyListType[] | [];
  dispatchResetSession: () => void;
  dispatchResetTimeSheetError: () => void;
  dispatchResetTimeSheetSuccess: () => void;
  dispatchResetTimeSheetMessage: () => void;
  dispatchResetTimeSheetStatusCode: () => void;
  dispatchGetTimeSheetVsSchedulingMonthlyReportAction: (
    data: GetTimesheetVsSchedulngMonthlyReport
  ) => void;
  dispatchResetTimesheetVsSchedulingMonthlyTotalCount: () => void;
  dispatchResetTimesheetVsSchedulingMonthlyList: () => void;
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  dispatchEmailTimesheetVsSchedulingMonthlyReportAction: (
    data: EmailTimesheetVsSchedulingMonthlyReportType
  ) => void;
};

const TimeSheetVsSchedulingMonthlyReport = ({
  token,
  error,
  statusCode,
  success,
  message,
  fetching,
  totalCount,
  userDepartmentList,
  usersEmailDepartmentFetching,
  usersDepartmentFetching,
  totalDepartmentCount,
  dispatchResetSession,
  dispatchResetTimeSheetSuccess,
  dispatchResetTimeSheetError,
  dispatchResetTimeSheetMessage,
  dispatchResetTimeSheetStatusCode,
  timesheetVsSchedulingMonthlyList,
  dispatchGetTimeSheetVsSchedulingMonthlyReportAction,
  dispatchResetTimesheetVsSchedulingMonthlyTotalCount,
  dispatchResetTimesheetVsSchedulingMonthlyList,
  dispatchGetMasterDataUsersDepartmentAction,
  dispatchEmailTimesheetVsSchedulingMonthlyReportAction,
}: Appprops) => {
  const [internalUserSelected, setInternalUserSelected] = useState<any>({
    value: null,
    label: "Select...",
  });
  // const { start, end }:any = getTwoMonthBackFromCurrent();
  const [startDate, setStartDate] = useState("");
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showData, setShowData] = useState(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [showBillable, setShowBillable] = useState(false);
  const [header, setHeader] = useState(
    showBillable
      ? TIMESHEET_SCHEDULING_BILLABLE_REPORT_HEADERS
      : TIMESHEET_VS_SCHEDULING_MONTHLY_REPORT_HEADERS
  );
  const [finalUsersDepartmentList, setFinalUsersDepartmentList] = useState<any>(
    []
  );
  const [emailFinalData, setEmailFinalData] = useState<any>({});

  const [department, setDepartment] = useState<SelectOptionType>({
    label: "Select...",
    value: null,
  });
  const [usersDepartmentOffset, setUsersDepartmentOffset] = useState<number>(0);
  const [usersEmailDepartmentOffset, setUsersEmailDepartmentOffset] =
    useState<number>(0);
  const [usersDepartmentText, setUsersDepartmentText] = useState<string>("");
  const [usersEmailDepartmentText, setUsersEmailDepartmentText] =
    useState<string>("");
  const [data, setData] = useState<[] | TimesheetVsSchedulingMonthlyListType[]>(
    []
  );

  // Email All User Timesheet Report states
  const [emailReportStartDate, setEmailReportStartDate] = useState<string>("");
  const [emailReportEndDate, setEmailReportEndDate] = useState<string>("");
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [emailDepartment, setEmailDepartment] = useState<SelectOptionType>({
    label: "Select Department",
    value: null,
  });

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };
  const checkUsersEmailDepartmentBottom = () => {
    setUsersEmailDepartmentOffset((prv: any) => prv + limit);
  };

  useEffect(() => {
    dispatchResetTimeSheetSuccess();
    dispatchResetTimeSheetError();
    dispatchResetTimeSheetMessage();
    dispatchResetTimeSheetStatusCode();
    dispatchResetTimesheetVsSchedulingMonthlyList();
    dispatchResetTimesheetVsSchedulingMonthlyTotalCount();
  }, []);

  const handleChangeStatus = () => {
    setShowBillable(!showBillable);
    setHeader([]);
  };

  useEffect(() => {
    if (timesheetVsSchedulingMonthlyList?.length === 0) {
      setData(timesheetVsSchedulingMonthlyList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...timesheetVsSchedulingMonthlyList]);
    } else {
      setData(timesheetVsSchedulingMonthlyList);
    }
  }, [timesheetVsSchedulingMonthlyList]);

  useEffect(() => {
    // dispatchResetTimesheetVsSchedulingMonthlyTotalCount();
    if (token) {
      if (startDate && endDate) {
        let finalData: GetTimesheetVsSchedulngMonthlyReport = {
          token,
          offset,
          limit,
          start_date: startDate ? reverseDateFormat(startDate) : "",
          end_date: endDate ? reverseDateFormat(endDate) : "",
          user_id: internalUserSelected?.value,
          department:
            department?.label === "Select..." ||
            department?.label === "All Departments"
              ? ""
              : department?.label,
        };
        if (totalCount) {
          if (offset < totalCount) {
            dispatchGetTimeSheetVsSchedulingMonthlyReportAction(finalData);
          }
        } else {
          dispatchGetTimeSheetVsSchedulingMonthlyReportAction(finalData);
        }
      }
    }
  }, [offset]);

  //Department List
  useEffect(() => {
    const finalDepartmentListData = userDepartmentList?.map((data: any) => {
      return {
        value: data?._id,
        label: `${data?.department_name}`,
      };
    });

    if (
      (usersDepartmentOffset > 0 || usersEmailDepartmentOffset > 0) &&
      finalUsersDepartmentList?.length &&
      finalDepartmentListData?.length
    ) {
      setFinalUsersDepartmentList([
        ...finalUsersDepartmentList,
        ...finalDepartmentListData,
      ]);
    } else if (finalDepartmentListData?.length) {
      setFinalUsersDepartmentList([...finalDepartmentListData]);
    }
    // else {
    //   setFinalUsersDepartmentList([]);
    // }
  }, [userDepartmentList]);

  useEffect(() => {
    if (token && totalDepartmentCount) {
      if (usersDepartmentOffset <= +totalDepartmentCount) {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: limit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    }
  }, [usersDepartmentOffset]);

  useEffect(() => {
    if (token && totalDepartmentCount) {
      if (usersEmailDepartmentOffset <= +totalDepartmentCount) {
        const finalData = {
          token,
          status: 1,
          offset: usersEmailDepartmentOffset,
          limit: limit,
          searchValue: usersEmailDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    }
  }, [usersEmailDepartmentOffset]);

  useDebounce(
    () => {
      if (usersDepartmentText) {
        fetchUsersDepartmentNewData("userDepartment");
      } else {
        setFinalUsersDepartmentList([]);
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: limit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [usersDepartmentText]
  );

  useDebounce(
    () => {
      if (usersEmailDepartmentText) {
        fetchUsersDepartmentNewData("email");
      } else {
        setFinalUsersDepartmentList([]);
        const finalData = {
          token,
          status: 1,
          offset: 0,
          limit: limit,
          searchValue: usersEmailDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [usersEmailDepartmentText]
  );

  const fetchUsersDepartmentNewData = (type: string) => {
    setFinalUsersDepartmentList([]);
    const finalData = {
      token,
      status: 1,
      offset: 0,
      limit: limit,
      searchValue:
        type === "email" ? usersEmailDepartmentText : usersDepartmentText,
    };
    dispatchGetMasterDataUsersDepartmentAction(finalData);
  };

  const handleDepartmentChange = (department: SelectOptionType) => {
    setDepartment(department);
  };
  const checkUsersDepartmentBottom = () => {
    setUsersDepartmentOffset((prv: any) => prv + limit);
  };

  const handleEmailReportStartDate = (date: any) => {
    setEmailReportStartDate(date);
  };

  const handleResetEmailEndDate = () => {
    setEmailReportEndDate("");
  };

  const handleEmailReportEndDate = (date: any) => {
    setEmailReportEndDate(date);
  };
  const handleEmailDepartmentChange = (department: SelectOptionType) => {
    setEmailDepartment(department);
  };
  const handleSubmitData = () => {
    // window.scrollTo(0, 0);
    setShowData(true);
    dispatchResetTimesheetVsSchedulingMonthlyTotalCount();
    setData([]);
    dispatchResetTimesheetVsSchedulingMonthlyList();
    if (token) {
      let finalData = {
        token,
        offset,
        limit,
        start_date: startDate ? reverseDateFormat(startDate) : "",
        end_date: endDate ? reverseDateFormat(endDate) : "",
        user_id: internalUserSelected?.value,
        department:
          department?.label === "Select..." ||
          department?.label === "All Departments"
            ? ""
            : department?.label,
      };
      if (offset === 0) {
        dispatchGetTimeSheetVsSchedulingMonthlyReportAction(finalData);
        setDisplayStartDate(handleDate(startDate));
        setDisplayEndDate(handleDate(endDate));
        setEmailFinalData(finalData);
      } else {
        setOffset(0);
        setDisplayStartDate(handleDate(startDate));
        setDisplayEndDate(handleDate(endDate));
      }
    }
  };
  // TRIGGER EMAIL FOR TIMESHEET SCHEDULING REPORT
  const handleEmailTimesheetVsSchedulingMonthlyReport = () => {
    if (token && emailReportStartDate && emailReportEndDate) {
      let finalData = {
        token,
        start_date: formatDate(emailReportStartDate),
        end_date: formatDate(emailReportEndDate),
        department:
          emailDepartment?.label === "Select Department" ||
          emailDepartment?.label === "All Departments"
            ? ""
            : emailDepartment?.label,
      };
      dispatchEmailTimesheetVsSchedulingMonthlyReportAction(finalData);
    }
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (timesheetVsSchedulingMonthlyList?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [timesheetVsSchedulingMonthlyList]);

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetError();
              dispatchResetTimesheetVsSchedulingMonthlyList();
            }}
          />
        );
      }
    }
    if (success === 1 && message === "Report has been fetched successfully.") {
      dispatchResetTimeSheetMessage();
      dispatchResetTimeSheetSuccess();
      dispatchResetTimesheetVsSchedulingMonthlyList();
    } else if (
      success === 1 &&
      message === "Email has been sent successfully!"
    ) {
      toast.success("Email has been sent successfully!", {
        duration: 2000,
      });
      dispatchResetTimeSheetMessage();
      dispatchResetTimeSheetSuccess();
    } else if (
      success === 1 &&
      message === "There was no data, hence email wasn't sent!"
    ) {
      toast.error("There was no data, hence email wasn't sent!", {
        duration: 2000,
      });
      dispatchResetTimeSheetMessage();
      dispatchResetTimeSheetSuccess();
    }
    return false;
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="Timesheet Scheduling Monthly Report" />
      </div>
      <div className="col-md-12 mt-3">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">
                Timesheet Scheduling Monthly List
                {!showData ? (
                  <> </>
                ) : (
                  <>
                    {!fetching && (
                      <div className="sub-heading mt-0">{`Total ${
                        totalCount ? totalCount : 0
                      } reports found`}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="right-heading position-relative d-flex"></div>
          </div>
          <div>
            <div className="d-flex ml-3">
              <div className="form-group">
                <label className="mb-1">
                  Month Range <span className="color-red">*</span>{" "}
                </label>
                <div>
                  <ReportsDateSelect
                    setToggle={setToggle}
                    toggle={toggle}
                    startDate={startDate ? startDate : ""}
                    endDate={endDate ? endDate : ""}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    type={"timesheetSchedulingReport"}
                    clearEndDate={true}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                  />
                </div>
              </div>
              <div
                style={{ maxWidth: "140px", marginRight: "48px" }}
                className="col-md-8 mb-2"
              >
                <div className="">
                  <InternalUsersDropdown
                    internalUserSelected={internalUserSelected}
                    setInternalUserSelected={setInternalUserSelected}
                    type={"timesheetSchedulingReport"}
                  />
                </div>
              </div>
              <div
                style={{ maxWidth: "175px" }}
                className="col-md-6 d-flex flex-column pl-0"
              >
                <label htmlFor="department">Department</label>
                <div className="mt-1">
                  <Select
                    options={
                      finalUsersDepartmentList?.length > 0
                        ? [
                            { label: "All Departments", value: null },
                            ...finalUsersDepartmentList,
                          ]
                        : []
                    }
                    value={department}
                    onChange={(department: any) =>
                      handleDepartmentChange(department)
                    }
                    isSearchable={true}
                    isLoading={usersDepartmentFetching}
                    onMenuClose={() => setUsersDepartmentOffset?.(0)}
                    onMenuScrollToBottom={checkUsersDepartmentBottom}
                    onInputChange={(e) => {
                      setUsersDepartmentText?.(e);
                      setUsersDepartmentOffset?.(0);
                    }}
                  />
                </div>
              </div>

              <div style={{ marginTop: "27px" }}>
                <button
                  className="btn btn-primary pl-3 pb-2"
                  onClick={handleSubmitData}
                >
                  Apply
                </button>
              </div>
              <div
                style={{
                  gap: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label className="switchs ml-3">
                  <input
                    type="checkbox"
                    checked={showBillable}
                    onChange={() => handleChangeStatus()}
                  />
                  <span className="sliders rounds"></span>
                </label>
                <span style={{ fontWeight: "500" }}>Show only Billable</span>
              </div>
              <div className="ml-2 mt-4">
                <EmailAllUserReportPopup
                  header={"Email Timesheet Scheduling Report"}
                  type={"AllUserAttendanceReport"}
                  showDropdown={showDropdown}
                  setShowDropdown={setShowDropdown}
                  setEmailDepartment={setEmailDepartment}
                  emailReportStartDate={emailReportStartDate}
                  emailReportEndDate={emailReportEndDate}
                  handleResetEmailEndDate={handleResetEmailEndDate}
                  handleEmailReportStartDate={handleEmailReportStartDate}
                  handleEmailReportEndDate={handleEmailReportEndDate}
                  handleEmailAllUserTimesheetReportData={
                    handleEmailTimesheetVsSchedulingMonthlyReport
                  }
                  finalUsersDepartmentList={
                    finalUsersDepartmentList?.length > 0
                      ? [
                          { label: "All Departments", value: null },
                          ...finalUsersDepartmentList,
                        ]
                      : []
                  }
                  emailDepartment={emailDepartment}
                  handleEmailDepartmentChange={handleEmailDepartmentChange}
                  usersDepartmentFetching={usersEmailDepartmentFetching}
                  setUsersDepartmentOffset={setUsersDepartmentOffset}
                  checkUsersDepartmentBottom={checkUsersEmailDepartmentBottom}
                  setUsersEmailDepartmentText={setUsersEmailDepartmentText}
                />
              </div>
            </div>
            {/* </div> */}
          </div>
          <div>
            {fetching && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : timesheetVsSchedulingMonthlyList?.length > 0 ? (
              <TimesheetVsSchedulingMonthlyTable
                data={data}
                fetching={fetching}
                offset={offset}
                startDate={reverseDateFormat(displayStartDate)}
                endDate={reverseDateFormat(displayEndDate)}
                showBillable={showBillable}
                setHeader={setHeader}
                header={header}
              />
            ) : (
              <>
                {!fetching && data?.length === 0 && (
                  <div className="pb-4 mt-5">
                    <EmptyListPage
                      title="No List Found!"
                      text="Choose month range to get timesheet scheduling monthly report !"
                      imageWidth="30%"
                      image={EmptyTimeSheetReportList}
                      showAddButton={false}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Toaster />

      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  totalCount: state.timeSheet.timesheetVsSchedulingMonthlyTotalCount,
  timesheetVsSchedulingMonthlyList:
    state.timeSheet.timesheetVsSchedulingMonthlyList,
  userDepartmentList: state.masterData.userDepartmentList,
  totalDepartmentCount: state.masterData.userDepartmentTotalCount,
  usersDepartmentFetching: state.masterData.fetching,
  usersEmailDepartmentFetching: state.masterData.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetStatusCode: () => dispatch(resetTimeSheetStatusCode()),
  dispatchGetTimeSheetVsSchedulingMonthlyReportAction: (
    data: GetTimesheetVsSchedulngMonthlyReport
  ) => dispatch(getTimeSheetVsSchedulingMonthlyReportAction(data)),
  dispatchResetTimesheetVsSchedulingMonthlyTotalCount: () =>
    dispatch(resetTimesheetVsSchedulingMonthlyTotalCount()),
  dispatchResetTimesheetVsSchedulingMonthlyList: () =>
    dispatch(resetTimesheetVsSchedulingMonthlyList()),
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataUsersDepartmentAction(data)),
  dispatchEmailTimesheetVsSchedulingMonthlyReportAction: (
    data: EmailTimesheetVsSchedulingMonthlyReportType
  ) => dispatch(emailTimesheetVsSchedulingMonthlyReportAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeSheetVsSchedulingMonthlyReport);
